<template>
  <div style="min-height: 750px;" v-if="d_usrDiscountWdm">
    <b-row>
      <b-col sm="12" lg="2"></b-col>
      <b-col sm="12" lg="8"></b-col>
      <b-col sm="12" lg="2"></b-col>
    </b-row>
    <b-row style="margin-bottom: 20px; border-bottom: solid 1px whitesmoke;">
      <b-col sm="12" md="2" lg="2"> </b-col>
      <b-col sm="12" md="4" lg="4">
        <i class="fa fa-desktop"></i>
        {{ StoreLangTranslation.data['user_discount_list'][StoreLang] }}
      </b-col>
      <b-col sm="12" md="4" lg="4" :style="StoreDevice.isMobile ? '' : 'text-align: right;'"></b-col>
      <b-col sm="12" md="2" lg="2"></b-col>
    </b-row>
    <b-row>
      <b-col sm="12" lg="2"></b-col>
      <b-col sm="12" lg="8">

        <b-row style="margin: 3px;">
          <b-col sm="12" lg="3">
            <strong> {{ StoreLangTranslation.data['user_search'][StoreLang] }} </strong>
          </b-col>
          <b-col sm="12" lg="9">
            <user-search :p_searchResult="d_userSearchResult" :p_searchMode="d_searchMode"></user-search>
          </b-col>
        </b-row>
        <hr/>
        <b-row style="margin-bottom: 10px;">
          <b-col sm="12" lg="6">
            <b-button size="sm" v-if="d_userShopClientID && (ClsUser.f_checkUserAuth(['admin', 'shop_admin', 'shop_bundle_add_edit']) || ClsUser.f_checkUserAuth([d_userShopClientID + '_shop_admin', d_userShopClientID + '_shop_bundle_add_edit'], 'with_id')) && d_userSearchResult.list.length > 0 && d_userSearchResult.list[d_userSearchResult.selected_index] && d_userSearchResult.list[d_userSearchResult.selected_index].username" @click="f_userDiscountList()" variant="primary">
              <i class="fa fa-refresh"></i>
            </b-button>
          </b-col>
          <b-col sm="12" lg="6" style="text-align: right;">
            <b-button size="sm" v-if="d_userShopClientID && (ClsUser.f_checkUserAuth(['admin', 'shop_admin', 'shop_bundle_add_edit']) || ClsUser.f_checkUserAuth([d_userShopClientID + '_shop_admin', d_userShopClientID + '_shop_bundle_add_edit'], 'with_id')) && d_userSearchResult.list.length > 0 && d_userSearchResult.list[d_userSearchResult.selected_index] && d_userSearchResult.list[d_userSearchResult.selected_index].username" @click="f_newUserDiscount()" variant="primary">
              {{ StoreLangTranslation.data['new_user_discount'][StoreLang] }}
            </b-button>
          </b-col>
        </b-row>
        <hr/>
        <template v-if="d_userSearchResult.list.length > 0 && d_userSearchResult.list[d_userSearchResult.selected_index] && d_userSearchResult.list[d_userSearchResult.selected_index].username">
            <b-row>
              <b-col sm="12" lg="12">
                <b-form-input id="search" v-model="d_searchText" :placeholder="StoreLangTranslation.data['write_for_filtering'][StoreLang]"></b-form-input>
              </b-col>
            </b-row>
            <b-row style="margin: 3px;">
              <b-col sm="12" lg="2">
                <strong> Id </strong>
              </b-col>
              <b-col sm="12" lg="2">
                <strong> {{ d_usrDiscountWdm['0']['parameters']['0']['name']['translation'][StoreLang] }} </strong>
              </b-col>
              <b-col sm="12" lg="5">
                <strong> {{ d_usrDiscountWdm['0']['parameters']['5']['name']['translation'][StoreLang] }} </strong>
              </b-col>
              <b-col sm="12" lg="2">
                <strong> {{ d_usrDiscountWdm['0']['parameters']['3']['name']['translation'][StoreLang] }} </strong>
              </b-col>
              <b-col sm="12" lg="1"> </b-col>
            </b-row>
            <template v-if="d_loadingUserDiscountList">
              <b-spinner variant="primary"></b-spinner>
            </template>
            <template v-else>
              <b-row v-for="(wdmr_item, wdmr_item_ind) in d_usrDiscountList" v-if="f_searchUserDiscount(wdmr_item)" @mouseover="d_hoverIndex = wdmr_item_ind" @mouseleave="d_hoverIndex = ''" :style="StoreDevice.isMobile ? 'cursor: pointer; margin: 10px; border-bottom: solid 1px #dcdcdc;' : 'cursor: pointer; margin: 1px; border-bottom: solid 1px #dcdcdc;'">
                <b-col sm="12" lg="2">
                  <small style="color: blue;" :title="wdmr_item.client_id"> {{ wdmr_item.client_id.substring(0,10) + '...' }} </small>
                </b-col>
                <b-col sm="12" lg="2">
                  
                  <template v-if="wdmr_item.data && wdmr_item.data['0'] && wdmr_item.data['0']['0'] && wdmr_item.data['0']['0']['val']['translation']">
                    <span :style="d_hoverIndex === wdmr_item_ind ? ' color: rgb(252, 0, 153, 1);' : ''">{{ wdmr_item.data['0']['0']['val']['translation'][StoreLang] }}</span>
                  </template>
                
                </b-col>
                <b-col sm="12" lg="5">
                  
                  <template v-if="wdmr_item.data && wdmr_item.data['0'] && wdmr_item.data['0']['5'] && wdmr_item.data['0']['5']['lang'] && wdmr_item.data['0']['5']['lang'][StoreLang]">
                    <span :style="d_hoverIndex === wdmr_item_ind ? ' color: rgb(252, 0, 153, 1);' : ''">{{ wdmr_item.data['0']['5']['lang'][StoreLang] }}</span>
                  </template>
                  <template v-else-if="wdmr_item.data && wdmr_item.data['0'] && wdmr_item.data['0']['5'] && wdmr_item.data['0']['5']['val']">
                    <span :style="d_hoverIndex === wdmr_item_ind ? ' color: rgb(252, 0, 153, 1);' : ''">{{ wdmr_item.data['0']['5']['val'] }}</span>
                  </template>
                
                </b-col>
                <b-col sm="12" lg="2">
                  
                  <template v-if="wdmr_item.data && wdmr_item.data['0'] && wdmr_item.data['0']['3'] && wdmr_item.data['0']['3']['val'] && wdmr_item.data['0']['3']['val']['value']">
                    <span :style="d_hoverIndex === wdmr_item_ind ? ' color: rgb(252, 0, 153, 1);' : ''">{{ wdmr_item.data['0']['3']['val']['value'] }}</span>
                  </template>
                
                </b-col>
                <b-col sm="12" lg="1">
                  <b-dropdown variant="white" size="sm" style="width: 100%; float: left;">
                    <template slot="button-content">
                      işlem
                    </template>
                    <b-dropdown-item v-if="ClsUser.f_checkUserAuth(['admin', 'shop_admin', 'shop_bundle_add_edit']) || ClsUser.f_checkUserAuth([d_userShopClientID + '_shop_admin', d_userShopClientID + '_shop_bundle_add_edit'], 'with_id')" @click="f_editThisUserDiscount(wdmr_item.client_id)"><i class="fa fa-edit"></i> {{ StoreLangTranslation.data['edit'][StoreLang] }} </b-dropdown-item>
                  </b-dropdown>
                </b-col>
              </b-row>
              
            </template>
          
        </template>
      </b-col>
      <b-col sm="12" lg="2"></b-col>
    </b-row>
  </div>
</template>

<script>

import { ClsUser } from '@/wam/modules/user';
import { ClsWdm } from '@/wam/modules/wdm';
import { ClsRoute } from '@/wam/modules/route';
import store from '@/store';
import { ServiceFunctions } from '@/wam/modules/service';
import {
  default as AgreementView
} from '@/wam/components/widgets/AgreementView';
import {
  default as UserSearch
} from '@/wam/components/widgets/UserSearch';
import { mapGetters } from 'vuex';
export default {
  name: 'user_discount_list',
  computed: mapGetters({
    StoreDevice: 'StoreDevice',
    StoreLang: 'StoreLang',
    StoreLangList: 'StoreLangList',
    StoreLangTranslation: 'StoreLangTranslation',
    StoreFrontendSettings: 'StoreFrontendSettings',
  }),
  components: {
    AgreementView,
    UserSearch
  },
  props: {},
  data () {
    return {
      d_user: '',
      d_hoverIndex: '',
      d_searchText: '',
      d_usrDiscountList: [],
      d_usrDiscountWdm: '',
      ClsUser: ClsUser,
      d_userSearchResult: {
        'selected_index': '',
        'search_text': '',
        'list': [],
      },
      d_searchMode: {
        'field_type': 'username', // username, all, mail, ve benzeri, smar
        'match_type': 'full' // full, include
      },
      d_loadingUserDiscountList: false,
    };
  },
  created: function () {
    ClsWdm.getLayerWdm('usr_discount').then(resp_wdm_data => { this.d_usrDiscountWdm = resp_wdm_data; });
    this.d_user = JSON.parse(localStorage.getItem('user'));
    this.d_userShopClientID = this.$route.query.user_shop_client_id;

    let auth_eligible = false;
    let user_perm_eligible = false;
    let user_perm_eligibleGeneral = false;
    if (this.$route.meta && this.$route.meta.permission && this.$route.meta.permission.length > 0) {
      auth_eligible = ClsUser.f_checkUserAuth(this.$route.meta.permission, 'without_id');
      if (auth_eligible) {
        user_perm_eligible = ClsUser.f_checkUserAuth([this.d_userShopClientID + '_shop_admin', this.d_userShopClientID + '_shop_bundle_add_edit'],'with_id');
        user_perm_eligibleGeneral = ClsUser.f_checkUserAuth(['admin', 'shop_admin', 'shop_bundle_add_edit']);
      }
    }
    if (this.d_user && this.d_user.username && auth_eligible && (user_perm_eligible || user_perm_eligibleGeneral) ) {
      // console.log('')
    } else {
      this.$router.push({ path: this.StoreLangTranslation.data['page_404_path'][this.StoreLang], query: {} });
    }
  },
  beforeMount () {},
  mounted: function () {
    // console.log(this.StoreFrontendSettings);
    // console.log(this.d_usrDiscountWdm);
  },
  methods: {
    f_newUserDiscount: function () {
      this.$router.push({ path: ClsRoute.f_getRoutePath('user_discount_record', this.StoreLang), query: {'user_shop_client_id': this.d_userShopClientID, 'user_client_id': this.d_userSearchResult.list[this.d_userSearchResult.selected_index].username} });
    },
    f_editThisUserDiscount: function (user_discount_client_id) {
      let route_path = ClsRoute.f_getRoutePath('user_discount_record', this.StoreLang);
      // console.log('route_path : ', route_path);
      this.$router.push({ path: route_path, query: { 'user_discount_client_id': user_discount_client_id, 'user_shop_client_id': this.d_userShopClientID, 'user_client_id': this.d_userSearchResult.list[this.d_userSearchResult.selected_index].username } });
    },
    f_searchUserDiscount: function (user_discount) {
      let res = false;
      if (this.d_searchText) {
        if (user_discount.w_id.toLocaleLowerCase().indexOf(this.d_searchText.toLocaleLowerCase()) !== -1) {
          res = true;
        }
      } else {
        res = true;
      }
      return res;
    },
    f_userDiscountList: function () {
      if (this.d_userSearchResult.list.length > 0 && this.d_userSearchResult.list[this.d_userSearchResult.selected_index] && this.d_userSearchResult.list[this.d_userSearchResult.selected_index].username) {
        this.d_loadingUserDiscountList = true;
        let query = '';
        if (this.d_userSearchResult.list.length > 0 && this.d_userSearchResult.list[this.d_userSearchResult.selected_index] && this.d_userSearchResult.list[this.d_userSearchResult.selected_index].username) {
          query = 'user_client_id=' + this.d_userSearchResult.list[this.d_userSearchResult.selected_index].username;
        }
        query += '&user_shop_client_id=' + this.d_userShopClientID;
        let data = {};
        ServiceFunctions.user_discount_list(query, data)
          .then(resp => {
            this.d_loadingUserDiscountList = false;
            if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
              if (resp.data.list) {
                this.d_usrDiscountList = resp.data.list;
              } else {
                alert(this.StoreLangTranslation.data['process_completed'][this.StoreLang]);
              }
            } else {
              alert(resp.data.status_code + ' = ' + resp.data.status_message);
            }
          });

      }
    },
  },
  watch: {
    'd_userSearchResult.list.length': function () {
      this.f_userDiscountList();
    }
  }
};

</script>

